export function getTuoiAcquistiColumns(ctx: any) {
	return [
			{ field: "itemID", title: "ID", width: 20, filterable: false, hidden: true, cell: "defaultCellTemplate", headerCell: "myHeaderCellTemplate", editHide: true },

			{ field: "numeroCompleto", title: "Adesione", width: 130, headerCell: "myHeaderCellTemplate", export: true },
			{ field: "pacchetto", title: ctx.$i18n.t("generico.prodotto").toString(), headerCell: "myHeaderCellTemplate", export: true, width: 100 },
			{
				field: "dataInserimento",
				title: "Data Acquisto",
				format: "{0:dd/MM/yyyy}",
				width: 150,
				headerCell: "myHeaderCellTemplate",
				type: "date",
				headerType: "daterange",
				export: true,
				exportRenderFunction: ctx.exportRenderDate
			},
			//{ field: "anno", title: "Anno", format: "{0:yyyy}", width: 90, headerCell: "myHeaderCellTemplate", type: "date", headerType: "daterange", filterable: false, sortable: false },
			{
				field: "inizioViaggio",
				title: "Inizio",
				format: "{0:dd/MM/yyyy}",
				width: 120,
				headerCell: "myHeaderCellTemplate",
				type: "renderfunction",
				headerType: "daterange",
				export: true,
				renderFunction: ctx.renderFunctionNoTimeZoneDate,
				exportRenderFunction: ctx.exportRenderDate
			},
			{
				field: "fineViaggio",
				title: "Fine",
				format: "{0:dd/MM/yyyy}",
				width: 120,
				headerCell: "myHeaderCellTemplate",
				type: "renderfunction",
				headerType: "daterange",
				export: true,
				renderFunction: ctx.renderFunctionNoTimeZoneDate,
				exportRenderFunction: ctx.exportRenderDate
			},
			{ field: "destinazione", title: "Destinazione", hidden: false, headerCell: "myHeaderCellTemplate", export: true, width: 120 },
			{
				field: "importoViaggio",
				title: "Importo",
				format: "{0:n2}",
				width: 90,
				headerCell: "myHeaderCellTemplate",
				headerType: "numeric",
				export: true,
				type: "renderfunction",
				renderFunction: ctx.renderCellImportoViaggio,
				//exportRenderFunction: ctx.exportRenderCellImportoViaggio,
				exportRenderFunction: ctx.exportRenderCellValuta,
				exportValueFunction: ctx.exportValueCellImportoViaggio,
				exportTotale: true
			},
			{ field: "numeroPartecipanti", title: "Pax", width: 80, headerCell: "myHeaderCellTemplate", type: "numeric-int", headerType: "numeric-int", export: true, exportTotale: true },
			
			{
				field: "partecipantiElenco",
				title: "Assicurati",
				type: "renderfunction",
				renderFunction: ctx.renderCellPartecipantiElenco,
				headerCell: "myHeaderCellTemplate",
				export: true,
				exportRenderFunction: ctx.exportRenderPartecipanti,
				exportWidth: 600,
				width: 150
			},
			{ field: "riferimentoPratica", title: "Riferimento", width: 130, headerCell: "myHeaderCellTemplate", export: true },
			{ field: "totalePremio", title: "Premio", format: "{0:c}", width: 80, headerCell: "myHeaderCellTemplate", type: "numeric", headerType: "numeric", export: true, exportRenderFunction: ctx.exportRenderCellValuta, exportTotale: true },
			{ field: "totalePremioImposte", title: "Imposte", format: "{0:c}", width: 80, headerCell: "myHeaderCellTemplate", type: "numeric", headerType: "numeric", export: true, exportRenderFunction: ctx.exportRenderCellValuta, exportTotale: true  },
			{ field: "totalePremioNetto", title: "Premio Imponibile", format: "{0:c}", width: 98, headerCell: "myHeaderCellTemplate", type: "numeric", headerType: "numeric", export: true, exportRenderFunction: ctx.exportRenderCellValuta, exportTotale: true  },
			{ field: "commissioni", title: "Commissioni", format: "{0:c}", width: 80, headerCell: "myHeaderCellTemplate", type: "numeric", headerType: "numeric", export: true, exportRenderFunction: ctx.exportRenderCellValuta, exportTotale: true  },
			{ field: "totaleRitenuta", title: "RA Commissioni", format: "{0:c}", width: 80, headerCell: "myHeaderCellTemplate", type: "numeric", headerType: "numeric", export: true, exportRenderFunction: ctx.exportRenderCellValuta, exportTotale: true  },
			{ field: "totalePremioDaPagare", title: "Da Pagare", format: "{0:c}", width: 89, headerCell: "myHeaderCellTemplate", type: "numeric", headerType: "numeric", export: true, exportRenderFunction: ctx.exportRenderCellValuta, exportTotale: true   },
			{ field: "importoPagato", title: "Pagato", format: "{0:c}", width: 89, headerCell: "myHeaderCellTemplate", type: "numeric", headerType: "numeric", export: true, exportRenderFunction: ctx.exportRenderCellValuta, exportTotale: true   },
			{ field: "importoSconto", title: "Sconto", format: "{0:c}", width: 89, headerCell: "myHeaderCellTemplate", type: "numeric", headerType: "numeric", export: true, exportRenderFunction: ctx.exportRenderCellValuta, exportTotale: true   },
			{ field: "saldo", title: "Saldo", format: "{0:c}", width: 89, headerCell: "myHeaderCellTemplate", type: "numeric", headerType: "numeric", export: true, exportRenderFunction: ctx.exportRenderCellValuta, exportValueFunction: ctx.exportValueCellSaldoAdesione,  exportTotale: true   },
			{ field: "contrattoNumero", title: "Contratto", width: 130, headerCell: "myHeaderCellTemplate", export: true },
			{ field: "utente", title: "Utente", width: 100, headerCell: "myHeaderCellTemplate", export: true },
			{
				field: "itemGUID",
				title: " ",
				width: 50,
				type: "download-file-adesione",
				downloadFileUrlType: "adesione",
				editHide: true,
				filterable: false
			}
		];
}
